function _get(key) {
    return window.sessionStorage.getItem(key);
};

function _add(key, data) {
    window.sessionStorage.setItem(key, data);
};

function _update(key, data) {
    window.sessionStorage.setItem(key, data);
};

function _remove(key) {
    window.sessionStorage.removeItem(key);
};

function _reset() {
    window.sessionStorage.clear();
};

export default {
    get: _get,
    add: _add,
    update: _update,
    remove: _remove,
    reset: _reset,
}
